import { EarnDetailsAsset } from '../types'
import { EarnCustomerAmountsView, EarnTotalEarningsView } from './viewState'

export interface UseEarnDetailsDataHandlers {
  onDeposit: (asset: EarnDetailsAsset) => void
  onWithdraw: (asset: EarnDetailsAsset) => void
}

export const EARN_DETAILS_STATE = {
  LOADING: 'LOADING',
  NOT_FOUND: 'NOT_FOUND',
  READY: 'READY',
} as const

export interface EarnDetailsLoadingState {
  detailsState: typeof EARN_DETAILS_STATE.LOADING
}

export interface EarnDetailsNotFoundState {
  detailsState: typeof EARN_DETAILS_STATE.NOT_FOUND
}

export type EarnDetailsLifecycleState = EarnDetailsLoadingState | EarnDetailsNotFoundState

export interface EarnDetailsReady {
  detailsState: typeof EARN_DETAILS_STATE.READY
  asset: string
  walletId: string
  earnRate: string
  summary: {
    allocatedFunds: string
    unallocatedFunds: string
  }
  isStatisticsLoading: boolean
  onDeposit: () => void
  onWithdraw: () => void
}

export interface EarnDirectDetailsReady extends EarnDetailsReady {
  myLifetimeEarnings: string
}

export type EarnDirectDetailsData = EarnDetailsLifecycleState | EarnDirectDetailsReady

export interface EarnEmbeddedDetailsReady extends EarnDetailsReady {
  epcTakesEarn: boolean
  customerEarnRate: string
  totalEarnings: EarnTotalEarningsView
  customerSummary: EarnCustomerAmountsView
}

export type EarnEmbeddedDetailsData = EarnDetailsLifecycleState | EarnEmbeddedDetailsReady
